export { Introduction, type Props } from './index.pc'
export { MobileIntroduction } from './index.mobile'
